import RxMaskedTextField from "./RxMaskedTextField";

export default RxMaskedTextField;
